// general
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// material ui
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Container from '@mui/material/Container';

// pages
import Home from './Home';

// custom components
import Appbar from '../components/Appbar'
import { CustomColorScheme } from '../components/CustomTheme';

export default function Index(props) {

  document.body.style.backgroundColor = CustomColorScheme['test'];

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
    >
      <Appbar />
      <Container
        maxWidth='false'
        sx={{
          maxWidth: 350,
        }}
      >
        <Routes>
          <Route
            path='/'
            element={
              <Home />
            }
          />
        </Routes>
      </Container>
    </LocalizationProvider>
  )
}